import React from 'react';

const microbeData = [
  { name: 'Streptococcus mitis', Movement: 6, Size: 4, Flexibility: 7, trait: 'Pressure Resistant' },
  { name: 'Bacillus cereus', Movement: 7, Size: 3, Flexibility: 9, trait: 'Heat Resistant' },
  { name: 'Pseudomonas fluorescens', Movement: 5, Size: 5, Flexibility: 8, trait: 'Light Sensitive' },
  { name: 'Clostridium botulinum', Movement: 6, Size: 2, Flexibility: 6, trait: 'Anaerobic' },
  { name: 'Escherichia coli', Movement: 8, Size: 6, Flexibility: 7, trait: 'Heat Resistant' },
  { name: 'Halobacterium salinarum', Movement: 4, Size: 4, Flexibility: 9, trait: 'Pressure Resistant' },
  { name: 'Lactobacillus brevis', Movement: 5, Size: 3, Flexibility: 5, trait: 'Anaerobic' },
  { name: 'Vibrio fischeri', Movement: 6, Size: 2, Flexibility: 6, trait: 'Light Sensitive' },
  { name: 'Mycobacterium smegmatis', Movement: 7, Size: 5, Flexibility: 8, trait: 'Pressure Resistant' },
  { name: 'Serratia marcescens', Movement: 4, Size: 6, Flexibility: 5, trait: 'Heat Resistant' },
];

const traitColors = {
  'Pressure Resistant': '#60A5FA',
  'Heat Resistant': '#F87171',
  'Anaerobic': '#A3E635',
  'Light Sensitive': '#FBBF24',
};

const traitIcons = {
  'Pressure Resistant': '🛡️',
  'Heat Resistant': '🔥',
  'Anaerobic': '🦠',
  'Light Sensitive': '☀️',
};

const attrIcons = {
  Movement: '🏃',
  Size: '📏',
  Flexibility: '🤸',
};

function MicrobeCard({ name, Movement, Size, Flexibility, trait }) {
  return (
    <div className="microbe-card flex flex-col items-center rounded-2xl bg-white shadow-md p-4 w-full sm:w-[calc(100%-16px)] md:w-56 min-h-[320px] border border-gray-100 relative">
      {/* Image placeholder */}
      <div className="w-16 h-16 rounded-full flex items-center justify-center mb-2 mt-2" style={{ background: traitColors[trait] + '22' }}>
        <span style={{ fontSize: 36 }}>{traitIcons[trait]}</span>
      </div>
      <div className="font-semibold text-base text-gray-800 mb-2 text-center">{name}</div>
      <div className="text-xs text-gray-400 mb-1">Attributes</div>
      <div className="flex flex-col gap-2 w-full mb-3">
        <div className="flex items-center justify-between w-full px-2">
          <span className="flex items-center gap-1 text-gray-600"><span>{attrIcons.Movement}</span>Movement</span>
          <span className="font-bold text-gray-800">{Movement}</span>
        </div>
        <div className="flex items-center justify-between w-full px-2">
          <span className="flex items-center gap-1 text-gray-600"><span>{attrIcons.Size}</span>Size</span>
          <span className="font-bold text-gray-800">{Size}</span>
        </div>
        <div className="flex items-center justify-between w-full px-2">
          <span className="flex items-center gap-1 text-gray-600"><span>{attrIcons.Flexibility}</span>Flexibility</span>
          <span className="font-bold text-gray-800">{Flexibility}</span>
        </div>
      </div>
      <div className="text-xs text-gray-400 mb-1">Trait</div>
      <div className="flex items-center gap-2 mt-1">
        <span className="inline-flex items-center justify-center w-6 h-6 rounded bg-white border" style={{ background: traitColors[trait], color: '#fff' }}>{traitIcons[trait]}</span>
        <span className="text-sm font-medium text-gray-700">{trait}</span>
      </div>
    </div>
  );
}

export default function FlexForceMicrobeCardsGrid() {
  return (
    <div className="w-full flex flex-wrap gap-4 md:gap-6 justify-center">
      {microbeData.map((microbe, idx) => (
        <MicrobeCard key={microbe.name + idx} {...microbe} />
      ))}
    </div>
  );
} 